/* eslint-disable react/no-unescaped-entities */
import React, { FC } from "react";

import { LegalDocumentVariables } from "../../types";

export const hu: FC<LegalDocumentVariables> = ({
  company,
  site,
  phone,
  email,
  address,
  country,
  province,
  city,
  postalCode,
  vatNumber,
  lastUpdated,
  privacyPolicyLink,
}) => (
  <>
    <div>
      <h1>FELHASZNÁLÁSI FELTÉTELEK</h1>
      <p>
        <strong>Utolsó frissítés: {lastUpdated}</strong>
      </p>
      <h2>JOGI FELTÉTELEINK ELFOGADÁSA</h2>
      <p>
        Mi, a(z) {company} („<strong>Társaság</strong>”, „<strong>mi</strong>”,
        „<strong>minket</strong>” vagy „<strong>miénk</strong>”), egy {country}{" "}
        országban bejegyzett vállalat vagyunk, amelynek székhelye: {address},{" "}
        {city}, {province} {postalCode}. Adószámunk: {vatNumber}.
      </p>
      <p>
        Mi üzemeltetjük a <a href={site}>{site}</a> weboldalt („
        <strong>Webhely</strong>”), valamint minden egyéb kapcsolódó terméket és
        szolgáltatást, amelyek hivatkoznak ezekre a jogi feltételekre, vagy
        amelyek ezekre mutató hivatkozást tartalmaznak („
        <strong>Jogi feltételek</strong>”) (együttesen a „
        <strong>Szolgáltatások</strong>”).
      </p>
      <p>
        A(z) {company} fejlett mérkőzéselemzést és fogadási tippeket nyújt a
        legnagyobb európai labdarúgó-bajnokságokhoz. Szolgáltatásunk részletes
        mérkőzés-előzeteseket, dinamikus előrejelzéseket, pontos
        végeredmény-tippek és csapategyészség-indexeket tartalmaz. Ezek az
        indexek olyan tényezőket értékelnek, mint motiváció, sérülések hatása,
        közelmúltbeli forma és taktikai előnyök. Személyre szabott fogadási
        tippeket kínálunk, kockázati szint szerint kategorizálva (biztonságos,
        értékes, kockázatos), kiszámított valószínűségekkel és a Kelly-kritérium
        alapján javasolt tétekkel. A felhasználók testre szabhatják élményüket
        az oddsok beállításával, a fogadások nyomon követésével és az AI
        teljesítmény monitorozásával különféle szűrők segítségével. E
        szolgáltatások igénybevételéhez érvényes fiókra és aktív előfizetésre
        van szükség a <a href={site}>{site}</a> oldalon. Felhívjuk figyelmét,
        hogy minden fogadás kockázattal jár, és a megadott tippek nem
        garantálnak profitot. A felhasználóknak javasoljuk, hogy minden
        mérkőzést külön-külön értékeljenek, mielőtt fogadást helyeznének el.
      </p>
      <p>
        Kapcsolatba léphet velünk telefonon a(z) {phone} számon, e-mailben a(z){" "}
        {email} címen, vagy postai úton a következő címen: {address}, {city},{" "}
        {province} {postalCode}, {country}.
      </p>
      <p>
        Ezek a jogi feltételek jogilag kötelező érvényű megállapodást képeznek
        Ön („<strong>Ön</strong>”), akár személyesen, akár valamely jogi személy
        nevében jár el, és a(z) {company} között, a Szolgáltatásokhoz való
        hozzáférésére és azok használatára vonatkozóan. Ön elfogadja, hogy a
        Szolgáltatások elérésével elolvasta, megértette és elfogadta jelen jogi
        feltételek valamennyi pontját. HA NEM ÉRT EGYET EZEN JOGI FELTÉTELEK
        BÁRMELYIKÉVEL, AKKOR KIFEJEZETTEN TILOS HASZNÁLNIA A SZOLGÁLTATÁSOKAT,
        ÉS AZONNAL BE KELL FEJEZNIE AZOK HASZNÁLATÁT.
      </p>
      <p>
        Előzetesen értesíteni fogjuk Önt a használt Szolgáltatásokban tervezett
        bármely változásról. A módosított jogi feltételek az e-mailben
        feltüntetett időpontban válnak hatályossá, vagy amikor azokat
        közzétesszük vagy értesítjük Önt a(z) {email} címén. A Szolgáltatások
        módosításainak hatálybalépését követő további használattal Ön elfogadja
        a módosított feltételeket.
      </p>
      <p>
        A Szolgáltatások használata kizárólag legalább 18 éves felhasználók
        számára engedélyezett. 18 év alatti személyek nem használhatják, illetve
        nem regisztrálhatnak a Szolgáltatásokra.
      </p>
      <p>
        Javasoljuk, hogy nyomtassa ki ezen jogi feltételek másolatát saját
        nyilvántartása céljából.
      </p>
      <h2>TARTALOMJEGYZÉK</h2>
      <ol>
        <li>
          <a href="#services">SZOLGÁLTATÁSAINK</a>
        </li>
        <li>
          <a href="#ip">SZELLEMI TULAJDONJOGOK</a>
        </li>
        <li>
          <a href="#userreps">FELHASZNÁLÓI NYILATKOZATOK</a>
        </li>
        <li>
          <a href="#userreg">FELHASZNÁLÓI REGISZTRÁCIÓ</a>
        </li>
        <li>
          <a href="#purchases">VÁSÁRLÁS ÉS FIZETÉS</a>
        </li>
        <li>
          <a href="#subscriptions">ELŐFIZETÉSEK</a>
        </li>
        <li>
          <a href="#prohibited">TILTOTT TEVÉKENYSÉGEK</a>
        </li>
        <li>
          <a href="#ugc">FELHASZNÁLÓ ÁLTAL LÉTREHOZOTT TARTALOM</a>
        </li>
        <li>
          <a href="#license">TARTALOM FELHASZNÁLÁSI ENGEDÉLYE</a>
        </li>
        <li>
          <a href="#socialmedia">KÖZÖSSÉGI MÉDIA</a>
        </li>
        <li>
          <a href="#thirdparty">HARMADIK FÉL WEBOLDALAI ÉS TARTALMAI</a>
        </li>
        <li>
          <a href="#sitemanage">SZOLGÁLTATÁSOK KEZELÉSE</a>
        </li>
        <li>
          <a href="#ppyes">ADATVÉDELMI IRÁNYELVEK</a>
        </li>
        <li>
          <a href="#terms">IDŐTARTAM ÉS MEGSZÜNTETÉS</a>
        </li>
        <li>
          <a href="#modifications">MÓDOSÍTÁSOK ÉS MEGSZAKÍTÁSOK</a>
        </li>
        <li>
          <a href="#law">IRÁNYADÓ JOG</a>
        </li>
        <li>
          <a href="#disputes">JOGVITÁK RENDEZÉSE</a>
        </li>
        <li>
          <a href="#corrections">HELYESBÍTÉSEK</a>
        </li>
        <li>
          <a href="#disclaimer">FELELŐSSÉG KIZÁRÁSA</a>
        </li>
        <li>
          <a href="#liability">FELELŐSSÉG KORLÁTOZÁSA</a>
        </li>
        <li>
          <a href="#indemnification">KÁRTALANÍTÁS</a>
        </li>
        <li>
          <a href="#userdata">FELHASZNÁLÓI ADATOK</a>
        </li>
        <li>
          <a href="#electronic">
            ELEKTRONIKUS KOMMUNIKÁCIÓ, TRANZAKCIÓK ÉS ALÁÍRÁSOK
          </a>
        </li>
        <li>
          <a href="#misc">EGYÉB RENDELKEZÉSEK</a>
        </li>
        <li>
          <a href="#contact">KAPCSOLAT</a>
        </li>
      </ol>
    </div>
    <div id="services">
      <h2>1. SZOLGÁLTATÁSAINK</h2>
      <p>
        A Szolgáltatások használata során nyújtott információ nem szándékozik
        terjesztésre vagy használatra olyan személy vagy szervezet által olyan
        joghatóságban vagy országban, ahol az ilyen terjesztés vagy használat
        törvénybe vagy szabályozásba ütközne, vagy amely minket regisztrációs
        kötelezettség alá vonna az adott joghatóságban vagy országban. Ennek
        megfelelően azok a személyek, akik úgy döntenek, hogy más helyekről
        férnek hozzá a Szolgáltatásokhoz, saját kezdeményezésükre teszik ezt, és
        kizárólag ők felelősek a helyi törvények betartásáért, amennyiben és
        amilyen mértékben azok alkalmazandók.
      </p>
    </div>
    <div id="ip">
      <h2>2. SZELLEMI TULAJDONJOGOK</h2>

      <h3>A mi szellemi tulajdonunk</h3>
      <p>
        Mi vagyunk a tulajdonosai vagy engedélyesei a Szolgáltatásainkban
        található összes szellemi tulajdonjognak, beleértve minden forráskódot,
        adatbázist, funkcionalitást, szoftvert, weboldal-dizájnt, hanganyagot,
        videót, szöveget, fényképet és grafikát (együttesen a „Tartalom”),
        valamint a bennük található védjegyeket, szolgáltatási védjegyeket és
        logókat („Védjegyek”).
      </p>
      <p>
        Tartalmainkat és Védjegyeinket az Egyesült Államokban és világszerte a
        szerzői jogi és védjegytörvények (valamint egyéb szellemi tulajdonjogok
        és tisztességtelen verseny elleni jogszabályok), valamint nemzetközi
        szerződések védik.
      </p>
      <p>
        A Tartalom és a Védjegyek a Szolgáltatásokban „AHOGY VANNAK” kerülnek
        biztosításra kizárólag személyes, nem kereskedelmi vagy belső üzleti
        célú felhasználásra.
      </p>

      <h3>A Szolgáltatásaink használata</h3>
      <p>
        Ezen jogi feltételek betartása mellett, beleértve az alább található „
        <a href="#prohibited">TILTOTT TEVÉKENYSÉGEK</a>” szakaszt is, nem
        kizárólagos, át nem ruházható, visszavonható engedélyt adunk Önnek a
        következőkre:
      </p>
      <ul>
        <li>hozzáférés a Szolgáltatásokhoz; és</li>
        <li>
          letölthet vagy kinyomtathat a Tartalom bármely részéből egy példányt,
          amelyhez jogszerű hozzáférése van.
        </li>
      </ul>
      <p>
        kizárólag személyes, nem kereskedelmi vagy belső üzleti célú
        felhasználásra.
      </p>
      <p>
        Kivéve, ha ebben a szakaszban vagy a jogi feltételeink más részeiben
        másként van rendelkezve, tilos a Szolgáltatások, Tartalom vagy Védjegyek
        bármely részét másolni, reprodukálni, összesíteni, újraközölni,
        feltölteni, posztolni, nyilvánosan megjeleníteni, kódolni, lefordítani,
        továbbítani, terjeszteni, értékesíteni, licencelni vagy bármilyen
        kereskedelmi célra felhasználni előzetes írásbeli engedélyünk nélkül.
      </p>
      <p>
        Ha bármilyen más módon kívánja használni a Szolgáltatásokat, Tartalmat
        vagy Védjegyeket, mint ahogy azt ez a szakasz vagy más része a jogi
        feltételeinknek engedélyezi, kérjük, kérelmét a következő e-mail címre
        küldje: {email}. Ha valaha engedélyt adunk Önnek a Szolgáltatásaink vagy
        Tartalmunk bármely részének közzétételére, reprodukálására vagy
        nyilvános megjelenítésére, akkor köteles minket feltüntetni a
        Szolgáltatások, Tartalom vagy Védjegyek tulajdonosaként vagy
        engedélyeseiként, valamint biztosítani, hogy a szerzői jogi vagy
        tulajdonosi figyelmeztetés megjelenjen vagy látható legyen a Tartalmunk
        közzétételekor, reprodukálásakor vagy megjelenítésekor.
      </p>
      <p>
        Fenntartunk minden jogot, amelyet nem adtunk kifejezetten Önnek a
        Szolgáltatásokra, Tartalomra és Védjegyekre vonatkozóan.
      </p>
      <p>
        Ezen szellemi tulajdonjogok bármely megsértése lényegi
        szerződésszegésnek minősül, és a Szolgáltatásaink használatára vonatkozó
        joga azonnal megszűnik.
      </p>

      <h3>Az Ön beküldött anyagai</h3>
      <p>
        Kérjük, figyelmesen olvassa el ezt a szakaszt és az alább található „
        <a href="#prohibited">TILTOTT TEVÉKENYSÉGEK</a>” szakaszt, mielőtt
        használná Szolgáltatásainkat, hogy megértse: (a) milyen jogokat ad át
        nekünk, és (b) milyen kötelezettségeket vállal, amikor tartalmat tölt
        fel vagy posztol a Szolgáltatásokon keresztül.
      </p>
      <p>
        <strong>Beküldött anyagok:</strong> Ha közvetlenül elküld nekünk
        kérdést, kommentet, javaslatot, ötletet, visszajelzést vagy egyéb
        információt a Szolgáltatásokkal kapcsolatban („Beküldött anyagok”), Ön
        hozzájárul, hogy a beküldött anyaghoz kapcsolódó minden szellemi
        tulajdonjogot ránk ruház. Ön elfogadja, hogy a beküldött anyagok a mi
        tulajdonunkat képezik, és jogosultak vagyunk azokat korlátozás nélkül
        felhasználni vagy terjeszteni bármely jogszerű célra, legyen az
        kereskedelmi vagy egyéb, anélkül hogy Önnek elismerést vagy díjazást
        fizetnénk.
      </p>
      <p>
        <strong>Ön felelős azért, amit posztol vagy feltölt:</strong> Ha beküld
        nekünk anyagokat a Szolgáltatások bármely részén keresztül, akkor Ön:
      </p>
      <ul>
        <li>
          megerősíti, hogy elolvasta és elfogadja a „
          <a href="#prohibited">TILTOTT TEVÉKENYSÉGEK</a>” részt, és nem
          posztol, küld, publikál, tölt fel vagy továbbít a Szolgáltatásokon
          keresztül olyan tartalmat, amely illegális, zaklató, gyűlöletkeltő,
          ártalmas, rágalmazó, obszcén, zaklató, visszaélésszerű,
          diszkriminatív, fenyegető, szexuálisan explicit, hamis, pontatlan,
          csaló vagy félrevezető;
        </li>
        <li>
          lemond az ilyen tartalmakhoz kapcsolódó bármely erkölcsi jogáról;
        </li>
        <li>
          szavatolja, hogy a tartalom eredeti, vagy joga van azt beküldeni;
        </li>
        <li>szavatolja, hogy a beküldött tartalom nem bizalmas információ.</li>
      </ul>
      <p>
        Ön kizárólagos felelősséget vállal a beküldött tartalmaiért, és
        vállalja, hogy megtérít minden olyan kárt, amelyet okoz.
      </p>
    </div>
    <div id="userreps">
      <h3>3. FELHASZNÁLÓI NYILATKOZATOK</h3>
      <p>
        A Szolgáltatások használatával Ön kijelenti és szavatolja, hogy: (1)
        minden regisztráció során megadott információ igaz, pontos, naprakész és
        teljes lesz; (2) gondoskodik ezen információk pontosságáról, és szükség
        szerint haladéktalanul frissíti azokat; (3) rendelkezik a szükséges jogi
        képességgel, és elfogadja ezeket a jogi feltételeket; (4) nem kiskorú
        abban a joghatóságban, ahol tartózkodik; (5) nem automatizált vagy nem
        emberi módon fér hozzá a Szolgáltatásokhoz, legyen az bot, script vagy
        más eszköz; (6) nem használja a Szolgáltatásokat illegális vagy
        jogosulatlan célokra; és (7) a Szolgáltatások használata során nem sérti
        meg a vonatkozó törvényeket vagy szabályozásokat.
      </p>
      <p>
        Ha Ön olyan információkat ad meg, amelyek hamisak, pontatlanok, nem
        naprakészek vagy hiányosak, jogunkban áll felfüggeszteni vagy
        megszüntetni a fiókját, valamint megtagadni a Szolgáltatások (vagy azok
        bármely részének) jelenlegi vagy jövőbeni használatát.
      </p>
    </div>
    <div id="userreg">
      <h2>4. FELHASZNÁLÓI REGISZTRÁCIÓ</h2>
      <p>
        Előfordulhat, hogy a Szolgáltatások használatához regisztrálnia kell. Ön
        vállalja, hogy jelszavát bizalmasan kezeli, és felelős lesz fiókjának és
        jelszavának minden használatáért. Fenntartjuk a jogot arra, hogy
        eltávolítsunk, visszaköveteljünk vagy megváltoztassunk egy Ön által
        választott felhasználónevet, amennyiben saját belátásunk szerint azt
        helytelennek, obszcénnek vagy egyéb módon kifogásolhatónak találjuk.
      </p>
    </div>
    <div id="purchases">
      <h2>5. VÁSÁRLÁS ÉS FIZETÉS</h2>
      <p>Az alábbi fizetési módokat fogadjuk el:</p>
      <ul>
        <li>Visa</li>
        <li>Mastercard</li>
        <li>Apple Pay</li>
        <li>Google Pay</li>
        <li>Stripe</li>
        <li>Revolut</li>
      </ul>
      <p>
        Ön vállalja, hogy naprakész, teljes és pontos vásárlási és
        számlainformációkat biztosít minden, a Szolgáltatásokon keresztül
        történő vásárláshoz. Emellett vállalja, hogy azonnal frissíti fiókjának
        és fizetési módjának információit, beleértve az e-mail címet, fizetési
        módot és bankkártya lejárati dátumát, hogy tranzakcióit végre tudjuk
        hajtani és szükség esetén kapcsolatba léphessünk Önnel. A vásárlások
        árához általunk meghatározott mértékű forgalmi adó kerül hozzáadásra. Az
        árakat bármikor módosíthatjuk. Minden fizetés euróban történik.
      </p>
      <p>
        Ön vállalja, hogy minden költséget az aktuálisan érvényes árakon fizet
        meg, beleértve az esetlegesen alkalmazandó szállítási díjakat is, és
        engedélyezi számunkra, hogy a kiválasztott fizetési szolgáltatón
        keresztül levonjuk a megrendelés leadásakor esedékes összeget.
        Fenntartjuk a jogot, hogy javítsunk bármilyen árazási hibát, még akkor
        is, ha már kérésre vagy fizetésre sor került.
      </p>
      <p>
        Fenntartjuk a jogot, hogy megtagadjuk bármely, a Szolgáltatásokon
        keresztül leadott megrendelést. Saját belátásunk szerint korlátozhatjuk
        vagy törölhetjük a személyenként, háztartásonként vagy rendelésenként
        vásárolható mennyiségeket. Ezek a korlátozások vonatkozhatnak ugyanazon
        ügyfélfiók által leadott megrendelésekre, azonos fizetési módra, illetve
        azonos számlázási vagy szállítási cím használatával leadott rendelésekre
        is. Fenntartjuk a jogot, hogy korlátozzuk vagy megtiltsuk azon
        megrendeléseket, amelyek megítélésünk szerint viszonteladók, kereskedők
        vagy disztribútorok által kerültek leadásra.
      </p>
    </div>
    <div id="subscriptions">
      <h2>6. ELŐFIZETÉSEK</h2>
      <h3>Számlázás és Megújítás</h3>
      <p>
        Előfizetése folyamatosan és automatikusan megújul, amíg azt le nem
        mondja. Ön hozzájárul, hogy fizetési módját ismétlődően megterheljük
        anélkül, hogy minden egyes ismétlődő terhelés előtt külön jóváhagyást
        kérnénk Öntől, egészen addig, amíg az adott megrendelést le nem mondja.
        Az Ön számlázási ciklusának hossza heti/havi.
      </p>
      <h3>Lemondás</h3>
      <p>
        Az előfizetését a <a href={site}>{site}</a> oldalon mondhatja le, a
        „Subscription” (Előfizetés) menüpont alatt a „Manage my subscription”
        (Előfizetésem kezelése) gombra kattintva. Egy másik lehetőségként írhat
        az info@football-gene.com címre. A lemondás a jelenlegi fizetett időszak
        végén lép életbe. Ha bármilyen kérdése van, vagy elégedetlen a
        Szolgáltatásainkkal, kérjük, írjon nekünk a(z) {email} címre.
      </p>
      <h3>Díjváltozások</h3>
      <p>
        Időről időre módosíthatjuk az előfizetési díjat, és az árváltozásokról a
        vonatkozó jogszabályoknak megfelelően értesítjük Önt.
      </p>
    </div>
    <div id="prohibited">
      <h2>7. TILTOTT TEVÉKENYSÉGEK</h2>
      <p>
        A Szolgáltatásokat nem használhatja más célra, mint amelyre azt
        elérhetővé tettük. A Szolgáltatásokat nem lehet kereskedelmi célokra
        használni, kivéve azokat, amelyeket kifejezetten jóváhagyunk vagy
        engedélyezünk.
      </p>
      <p>A Szolgáltatások felhasználójaként Ön vállalja, hogy nem fog:</p>
      <ul>
        <li>
          Szisztematikusan adatokat vagy egyéb tartalmakat gyűjteni vagy
          összeállítani a Szolgáltatásokból közvetlenül vagy közvetve, írásos
          engedélyünk nélkül.
        </li>
        <li>
          Félrevezetni, megtéveszteni minket vagy más felhasználókat, különösen
          érzékeny fiókinformációk, például jelszavak megszerzése érdekében.
        </li>
        <li>
          Megkerülni, letiltani vagy bármilyen módon beavatkozni a
          Szolgáltatások biztonsági funkcióiba, beleértve azokat, amelyek
          megakadályozzák vagy korlátozzák a Tartalom használatát vagy
          másolását, vagy amelyek korlátozzák a Szolgáltatások használatát.
        </li>
        <li>
          Becsmérelni, lejáratni, vagy egyéb módon kárt okozni nekünk és/vagy a
          Szolgáltatásoknak.
        </li>
        <li>
          A Szolgáltatásokból szerzett információkat mások zaklatására,
          bántalmazására vagy károkozásra használni.
        </li>
        <li>
          Visszaélni támogatási szolgáltatásainkkal, vagy hamis jelentéseket
          küldeni visszaélésről vagy helytelen magatartásról.
        </li>
        <li>
          A Szolgáltatásokat alkalmazandó törvényekkel vagy szabályozásokkal
          ellentétes módon használni.
        </li>
        <li>
          Engedély nélküli framing-et vagy linkelést végezni a
          Szolgáltatásokhoz.
        </li>
        <li>
          Feltölteni vagy továbbítani (vagy megkísérelni feltölteni vagy
          továbbítani) vírusokat, trójai programokat vagy egyéb anyagokat,
          amelyek zavarják a Szolgáltatások zavartalan használatát vagy
          működését.
        </li>
        <li>
          Automatizált rendszert használni, például szkripteket kommentek vagy
          üzenetek küldésére, adatgyűjtő robotokat vagy hasonló eszközöket
          használni.
        </li>
        <li>
          Eltávolítani a Tartalomból a szerzői jogi vagy más tulajdonjogi
          figyelmeztetéseket.
        </li>
        <li>
          Más felhasználóként vagy személyként kiadni magát, vagy más
          felhasználó nevét használni.
        </li>
        <li>
          Feltölteni vagy továbbítani (vagy megkísérelni feltölteni vagy
          továbbítani) olyan anyagokat, amelyek passzív vagy aktív
          információgyűjtő vagy továbbító mechanizmusként működnek, mint például
          gif-ek, web beacon-ök, sütik (cookies) vagy más hasonló eszközök.
        </li>
        <li>
          Megzavarni, akadályozni vagy túlzott terhelést okozni a
          Szolgáltatásoknak vagy azokhoz kapcsolódó hálózatoknak.
        </li>
        <li>
          Zaklatni, bosszantani, megfélemlíteni vagy fenyegetni bármely
          alkalmazottunkat vagy ügynökünket.
        </li>
        <li>
          Megpróbálni megkerülni a Szolgáltatások hozzáférésének korlátozására
          szolgáló intézkedéseket.
        </li>
        <li>
          Másolni vagy adaptálni a Szolgáltatások szoftverét, ideértve, de nem
          kizárólagosan a Flash, PHP, HTML, JavaScript vagy egyéb kódokat.
        </li>
        <li>
          A Szolgáltatások részét képező szoftvert visszafejteni, dekompilálni
          vagy visszafordítani, kivéve ha azt a vonatkozó jogszabályok
          megengedik.
        </li>
        <li>
          Automatizált rendszereket használni, kivéve a szabványos
          keresőmotorokat vagy böngészőket.
        </li>
        <li>
          Vásárlási ügynököt vagy beszerzési ügynököt alkalmazni a
          Szolgáltatásokon keresztül történő vásárlásokhoz.
        </li>
        <li>
          Jogosulatlan módon gyűjteni felhasználóneveket vagy e-mail címeket,
          kéretlen levelek küldése vagy hamis előfeltételekkel történő fiókok
          létrehozása céljából.
        </li>
        <li>
          A Szolgáltatásokat versenytárs tevékenységéhez használni, vagy
          bevételszerző vállalkozásokban alkalmazni.
        </li>
        <li>Profilját eladni vagy átruházni.</li>
        <li>
          A Szolgáltatásokat reklámozásra vagy áruk és szolgáltatások
          értékesítésére használni.
        </li>
      </ul>
    </div>
    <div id="ugc">
      <h2>8. FELHASZNÁLÓ ÁLTAL LÉTREHOZOTT TARTALOM</h2>
      <p>
        A Szolgáltatások nem kínálnak lehetőséget a felhasználók számára
        tartalom beküldésére vagy posztolására. Ugyanakkor lehetőséget
        biztosíthatunk Önnek tartalmak létrehozására, beküldésére,
        közzétételére, megjelenítésére, továbbítására, előadására,
        publikálására, terjesztésére vagy sugárzására, ideértve többek között a
        szöveget, írásokat, videókat, hanganyagokat, fényképeket, grafikákat,
        kommenteket, javaslatokat, személyes adatokat vagy egyéb anyagokat
        (együttesen „Hozzájárulások”). A Hozzájárulások láthatóak lehetnek más
        felhasználók számára, valamint harmadik fél weboldalain keresztül is.
        Így az Ön által továbbított bármely Hozzájárulást a Szolgáltatások
        Adatvédelmi irányelveivel összhangban kezeljük. Amikor Hozzájárulásokat
        készít vagy tesz elérhetővé, Ön kijelenti és garantálja, hogy:
      </p>
      <ul>
        <li>
          A Hozzájárulások létrehozása, terjesztése, továbbítása, nyilvános
          megjelenítése vagy előadása, valamint hozzáférése, letöltése vagy
          másolása nem sérti és nem fogja sérteni harmadik fél tulajdonjogait,
          ideértve többek között a szerzői jogokat, szabadalmakat, védjegyeket,
          üzleti titkokat vagy erkölcsi jogokat.
        </li>
        <li>
          Ön a Hozzájárulások létrehozója és tulajdonosa, vagy rendelkezik a
          szükséges licencekkel, jogokkal, hozzájárulásokkal és engedélyekkel,
          amelyek lehetővé teszik számunkra, a Szolgáltatásoknak és más
          felhasználóknak, hogy a Hozzájárulásokat bármilyen módon használják,
          amit ezek a jogi feltételek és a Szolgáltatások lehetővé tesznek.
        </li>
        <li>
          Minden egyes azonosítható személytől rendelkezik írásbeli
          hozzájárulással, amely lehetővé teszi azok nevének vagy képmásának
          felhasználását, hogy a Hozzájárulásokat a Szolgáltatások és ezek a
          jogi feltételek által lehetővé tett módon használhassuk.
        </li>
        <li>A Hozzájárulásai nem hamisak, pontatlanok vagy félrevezetőek.</li>
        <li>
          A Hozzájárulásai nem kéretlen vagy jogosulatlan reklámanyagok,
          promóciós anyagok, piramisjátékok, lánclevelek, spam, tömeges
          levelezések vagy egyéb kéretlen ajánlatok.
        </li>
        <li>
          A Hozzájárulásai nem obszcének, illetlenek, erkölcstelenek, mocskosak,
          erőszakosak, zaklatók, rágalmazók vagy egyéb módon kifogásolhatók
          (saját megítélésünk szerint).
        </li>
        <li>
          A Hozzájárulásai nem gúnyolnak, nem becsmérelnek, nem félemlítenek
          meg, és nem bántalmaznak másokat.
        </li>
        <li>
          A Hozzájárulásait nem használja más személy zaklatására vagy
          fenyegetésére, illetve erőszakra való buzdításra.
        </li>
        <li>
          A Hozzájárulásai nem sértenek semmilyen vonatkozó törvényt,
          szabályozást vagy előírást.
        </li>
        <li>
          A Hozzájárulásai nem sértik harmadik fél adatvédelmi vagy személyiségi
          jogait.
        </li>
        <li>
          A Hozzájárulásai nem sértenek gyermekpornográfiával kapcsolatos
          törvényeket, vagy olyan tartalmakat, amelyek kiskorúak egészségét vagy
          jólétét veszélyeztetik.
        </li>
        <li>
          A Hozzájárulásai nem tartalmaznak sértő megjegyzéseket faji,
          nemzetiségi, nemi, szexuális irányultsági vagy testi fogyatékossági
          alapon.
        </li>
        <li>
          A Hozzájárulásai nem sértenek más módon semmilyen rendelkezést ezekben
          a jogi feltételekben vagy vonatkozó törvényben, szabályozásban.
        </li>
      </ul>
      <p>
        A Szolgáltatások bármilyen, a fentieket sértő használata ezen jogi
        feltételek megsértését jelenti, és többek között a Szolgáltatások
        használatának megszüntetéséhez vagy felfüggesztéséhez vezethet.
      </p>
    </div>
    <div id="license">
      <h2>9. TARTALOM FELHASZNÁLÁSI ENGEDÉLYE</h2>
      <p>
        Ön és a Szolgáltatások megállapodnak abban, hogy bármilyen Ön által
        nyújtott információhoz és személyes adathoz hozzáférhetünk, tárolhatjuk,
        feldolgozhatjuk és felhasználhatjuk azokat az Adatvédelmi irányelvek és
        az Ön választásai (beleértve a beállításokat) szerint.
      </p>
      <p>
        Amennyiben javaslatokat vagy egyéb visszajelzéseket nyújt be a
        Szolgáltatásokkal kapcsolatban, elfogadja, hogy azokat bármilyen célra
        felhasználhatjuk és megoszthatjuk, anélkül, hogy Önnek ezért bármilyen
        díjazást fizetnénk.
      </p>
      <p>
        Nem tartunk igényt a Hozzájárulásai tulajdonjogára. Ön megőrzi minden
        Hozzájárulásának teljes tulajdonjogát, valamint a Hozzájárulásaihoz
        kapcsolódó szellemi tulajdonjogokat vagy más tulajdonjogokat. Nem
        vállalunk felelősséget a Hozzájárulásaiban tett kijelentésekért vagy
        állításokért, amelyeket Ön a Szolgáltatások bármely részén megad. Ön
        kizárólagos felelősséget visel a Szolgáltatásokhoz való
        Hozzájárulásaiért, és kifejezetten vállalja, hogy minket mentesít minden
        felelősség alól, valamint tartózkodik minden velünk szembeni jogi
        lépéstől a Hozzájárulásai kapcsán.
      </p>
    </div>
    <div id="socialmedia">
      <h2>10. KÖZÖSSÉGI MÉDIA</h2>
      <p>
        A Szolgáltatások funkcionalitásának részeként Ön összekapcsolhatja
        fiókját harmadik fél szolgáltatókkal fenntartott online fiókjaival
        (mindegyik ilyen fiók: „Harmadik fél fiókja”), mégpedig úgy, hogy: (1)
        megadja Harmadik fél fiókjának bejelentkezési adatait a Szolgáltatásokon
        keresztül, vagy (2) lehetővé teszi számunkra, hogy hozzáférjünk Harmadik
        fél fiókjához az adott fiókra vonatkozó feltételek szerint. Ön kijelenti
        és szavatolja, hogy jogosult megadni nekünk a Harmadik fél fiókjának
        bejelentkezési adatait, illetve engedélyezni számunkra a hozzáférést a
        Harmadik fél fiókjához anélkül, hogy megsértené a Harmadik fél fiókjának
        használatára vonatkozó feltételeket, továbbá anélkül, hogy bármilyen
        díjfizetési kötelezettség terhelné minket, vagy használati
        korlátozásokat szabna számunkra a harmadik fél szolgáltatója által.
        Harmadik fél fiókjaihoz való hozzáférés biztosításával Ön tudomásul
        veszi, hogy (1) hozzáférhetünk, elérhetővé tehetjük és tárolhatjuk (ha
        szükséges) az Ön által Harmadik fél fiókjában tárolt bármilyen tartalmat
        („Közösségi tartalom”), amely így elérhető lesz a Szolgáltatásokon
        keresztül, beleértve például az ismerőslistákat, és (2) további
        információkat küldhetünk és kaphatunk a Harmadik fél fiókjából olyan
        mértékben, ahogy arról tájékoztatást kapott a fiókok összekapcsolásakor.
        Attól függően, hogy mely Harmadik fél fiókjait választja, és figyelembe
        véve a Harmadik fél fiókjaiban beállított adatvédelmi beállításait, az
        Ön által posztolt személyazonosításra alkalmas adatok elérhetővé
        válhatnak a Szolgáltatásokon keresztül is. Kérjük, vegye figyelembe,
        hogy ha egy Harmadik fél fiókja vagy kapcsolódó szolgáltatása nem érhető
        el, vagy a hozzáférésünket a harmadik fél megszünteti, akkor a Közösségi
        tartalom sem lesz többé elérhető a Szolgáltatásokon keresztül. Ön
        bármikor megszüntetheti a Szolgáltatások és Harmadik fél fiókjai közötti
        kapcsolatot. FELHÍVJUK FIGYELMÉT, HOGY AZ ÖN ÉS A HARMADIK FÉL
        SZOLGÁLTATÓK KÖZÖTTI VISZONYT KIZÁRÓLAG AZ ÖN ÉS AZ ADOTT HARMADIK FÉL
        SZOLGÁLTATÓ KÖZÖTTI MEGÁLLAPODÁS(OK) SZABÁLYOZZÁK. Nem vállalunk
        kötelezettséget arra, hogy bármilyen Közösségi tartalmat ellenőrizzünk,
        beleértve annak pontosságát, jogszerűségét vagy jogsértés-mentességét,
        és nem vállalunk felelősséget az ilyen tartalmakért. Ön tudomásul veszi
        és elfogadja, hogy kizárólag azzal a céllal férhetünk hozzá a Harmadik
        fél fiókjához tartozó e-mail címjegyzékéhez, valamint mobileszközén vagy
        táblagépén tárolt névjegyzékéhez, hogy azonosítsuk és értesítsük Önt
        arról, ha ismerősei regisztráltak a Szolgáltatásokra. A Szolgáltatások
        és Harmadik fél fiókja közötti kapcsolat megszüntetését bármikor
        kezdeményezheti a lent megadott elérhetőségeinken, vagy fiókja
        beállításaiban (ha elérhető). Megpróbálunk minden olyan információt
        törölni szervereinkről, amelyet a Harmadik fél fiókjából kaptunk, kivéve
        a felhasználónevet és profilképet, amelyek a fiókjához kapcsolódnak.
      </p>
    </div>
    <div id="thirdparty">
      <h2>11. HARMADIK FÉL WEBOLDALAI ÉS TARTALMAI</h2>
      <p>
        A Szolgáltatások tartalmazhatnak (vagy a Webhelyen keresztül
        elküldhetünk Önnek) más weboldalakra mutató hivatkozásokat („Harmadik
        Fél Weboldalai”), valamint cikkeket, fényképeket, szövegeket,
        grafikákat, képeket, terveket, zenét, hangot, videókat, információkat,
        alkalmazásokat, szoftvereket és más, harmadik felektől származó
        tartalmakat vagy elemeket („Harmadik Fél Tartalma”). Az ilyen Harmadik
        Fél Weboldalait és Tartalmait nem vizsgáljuk, nem ellenőrizzük vagy
        követjük nyomon pontosság, megfelelőség vagy teljesség szempontjából, és
        nem vállalunk felelősséget a Szolgáltatásokon keresztül elérhető
        Harmadik Fél Weboldalaiért vagy a Szolgáltatásokon keresztül közzétett,
        elérhető vagy telepített Harmadik Fél Tartalmaiért, ideértve a tartalom
        pontosságát, sértő jellegét, véleményét, megbízhatóságát, adatvédelmi
        gyakorlatát vagy más politikáját. A Harmadik Fél Weboldalainak vagy
        Harmadik Fél Tartalmainak beillesztése, linkelése vagy használatának
        engedélyezése nem jelenti azok jóváhagyását vagy támogatását részünkről.
        Ha úgy dönt, hogy elhagyja a Szolgáltatásokat és hozzáfér a Harmadik Fél
        Weboldalaihoz, vagy használja vagy telepíti a Harmadik Fél Tartalmát,
        ezt kizárólag saját kockázatára teszi, és tudomásul kell vennie, hogy
        ezen jogi feltételek már nem irányadóak. Fel kell tekintenie minden
        olyan weboldal vonatkozó feltételeit és politikáit, ideértve az
        adatvédelmi és adatgyűjtési gyakorlatokat is, amelyekre a
        Szolgáltatásokból navigál, vagy amelyeket a Szolgáltatásokból használ
        vagy telepít. Bármilyen vásárlás, amelyet Harmadik Fél Weboldalain
        keresztül végez, kizárólag Ön és az adott harmadik fél között történik,
        és semmilyen felelősséget nem vállalunk az ilyen vásárlásokért. Ön
        elfogadja és elismeri, hogy nem támogatjuk a Harmadik Fél Weboldalain
        kínált termékeket vagy szolgáltatásokat, és teljes mértékben mentesít
        minket minden olyan kár alól, amelyet ezek a vásárlások okoznak Önnek.
        Továbbá mentesít minket minden olyan veszteség vagy kár alól, amely Önt
        érheti a Harmadik Fél Tartalmaival kapcsolatos vagy az ezekkel a
        weboldalakkal való kapcsolatából eredően.
      </p>
    </div>
    <div id="sitemanage">
      <h2>12. SZOLGÁLTATÁSOK KEZELÉSE</h2>
      <p>
        Fenntartjuk a jogot, de nem vagyunk kötelesek: (1) ellenőrizni a
        Szolgáltatásokat ezen jogi feltételek megsértése miatt; (2) megfelelő
        jogi lépéseket tenni bárkivel szemben, aki saját megítélésünk szerint
        megsérti a törvényeket vagy ezen jogi feltételeket, beleértve az illető
        jelentését a bűnüldöző szerveknek; (3) saját belátásunk szerint,
        korlátozás nélkül megtagadni, korlátozni vagy letiltani (amennyiben
        technológiailag lehetséges) bármely Hozzájárulásának vagy annak egy
        részének elérhetőségét; (4) saját belátásunk szerint, korlátozás,
        értesítés vagy felelősség nélkül eltávolítani a Szolgáltatásokból vagy
        egyéb módon letiltani azokat a fájlokat és tartalmakat, amelyek túlzott
        méretűek vagy más módon megterhelik rendszerünket; és (5) egyéb módon
        kezelni a Szolgáltatásokat jogaink és tulajdonunk védelme érdekében,
        valamint a Szolgáltatások megfelelő működésének biztosítása céljából.
      </p>
    </div>
    <div id="ppyes">
      <h2>13. ADATVÉDELMI IRÁNYELVEK</h2>
      <p>
        Fontos számunkra az adatvédelem és adatbiztonság. Kérjük, tekintse át
        Adatvédelmi irányelveinket:
        <strong>
          &nbsp;
          <a href={privacyPolicyLink}>{privacyPolicyLink}</a>
        </strong>
        . A Szolgáltatások használatával Ön elfogadja az Adatvédelmi
        irányelveinket, amelyek részét képezik ezen jogi feltételeknek.
        Felhívjuk figyelmét, hogy a Szolgáltatások Írországban kerülnek
        hosztolásra. Amennyiben a világ olyan régiójából fér hozzá a
        Szolgáltatásokhoz, ahol a személyes adatok gyűjtésére, felhasználására
        vagy nyilvánosságra hozatalára vonatkozó törvények eltérnek az
        Írországban alkalmazottaktól, akkor a Szolgáltatások folytatólagos
        használatával Ön beleegyezik abba, hogy adatait Írországba továbbítsuk
        és ott kezeljük.
      </p>
    </div>
    <div id="terms">
      <h2>14. IDŐTARTAM ÉS MEGSZÜNTETÉS</h2>
      <p>
        Ezen jogi feltételek mindaddig érvényben maradnak, amíg Ön használja a
        Szolgáltatásokat. ANÉLKÜL, HOGY KORLÁTOZNÁNK EZEN JOGI FELTÉTELEK
        BÁRMELY RENDELKEZÉSÉT, FENNTARTJUK A JOGOT, HOGY SAJÁT BELÁTÁSUNK
        SZERINT, ELŐZETES ÉRTESÍTÉS VAGY FELELŐSSÉG NÉLKÜL MEGTAGADJUK A
        SZOLGÁLTATÁSOKHOZ VALÓ HOZZÁFÉRÉST ÉS HASZNÁLATOT (BELEÉRTVE EGYES IP
        CÍMEK BLOKKOLÁSÁT) BÁRKITŐL, BÁRMILYEN OKBÓL VAGY AKÁR OK NÉLKÜL,
        BELEÉRTVE, DE NEM KIZÁRÓLAGOSAN, HA ÖN MEGSÉRTI EZEN JOGI FELTÉTELEK
        VALAMELY KIJELENTÉSÉT, GARANCIÁJÁT VAGY RENDELKEZÉSÉT, VAGY BÁRMILYEN
        ALKALMAZANDÓ TÖRVÉNYT VAGY SZABÁLYOZÁST. MEGSZÜNTETHETJÜK A
        SZOLGÁLTATÁSOKBAN VALÓ RÉSZVÉTELÉT VAGY TÖRÖLHETJÜK FIÓKJÁT ÉS BÁRMELY
        KÖZZÉTETT TARTALMÁT VAGY INFORMÁCIÓJÁT BÁRMIKOR, FIGYELMEZTETÉS NÉLKÜL,
        SAJÁT BELÁTÁSUNK SZERINT.
      </p>
      <p>
        Ha bármilyen okból megszüntetjük vagy felfüggesztjük fiókját, tilos
        Önnek új fiókot létrehoznia a saját nevével, hamis vagy kölcsönzött
        névvel vagy harmadik fél nevében, még akkor is, ha harmadik fél nevében
        jár el. A fiókja megszüntetésén vagy felfüggesztésén túl fenntartjuk a
        jogot megfelelő jogi lépések megtételére, ideértve polgári jogi,
        büntetőjogi és ideiglenes intézkedéseket is.
      </p>
    </div>
    <div id="modifications">
      <h2>15. MÓDOSÍTÁSOK ÉS MEGSZAKÍTÁSOK</h2>
      <p>
        Fenntartjuk a jogot, hogy a Szolgáltatások tartalmát bármikor, bármilyen
        okból, saját belátásunk szerint, előzetes értesítés nélkül
        megváltoztassuk, módosítsuk vagy eltávolítsuk. Nem vállalunk
        kötelezettséget a Szolgáltatásokon található információk frissítésére.
        Nem vállalunk felelősséget sem Ön, sem harmadik fél felé semmilyen
        módosítás, árváltoztatás, felfüggesztés vagy a Szolgáltatások
        megszüntetése miatt.
      </p>
      <p>
        Nem garantálhatjuk, hogy a Szolgáltatások folyamatosan elérhetőek
        lesznek. Technikai problémák vagy karbantartási munkák miatt
        előfordulhatnak megszakítások, késések vagy hibák. Fenntartjuk a jogot,
        hogy bármikor előzetes értesítés nélkül megváltoztassuk, frissítsük,
        felfüggesszük vagy megszüntessük a Szolgáltatásokat. Ön elfogadja, hogy
        nem vállalunk felelősséget semmilyen veszteségért, kárért vagy
        kellemetlenségért, amely abból adódik, hogy nem tud hozzáférni vagy
        használni a Szolgáltatásokat.
      </p>
    </div>
    <div id="law">
      <h2>16. IRÁNYADÓ JOG</h2>
      <p>
        Ezen jogi feltételekre {country} törvényei vonatkoznak, és a nemzetközi
        adásvételi szerződésekről szóló ENSZ-egyezmény alkalmazása kizárt. Ha Ön
        az EU-ban lakik, mint fogyasztó, az Ön lakóhelye szerinti ország
        kötelező rendelkezéseinek védelme is megilleti Önt. Ön és a(z) {company}{" "}
        egyaránt aláveti magát Budapest nem kizárólagos bírósági
        illetékességének, ami azt jelenti, hogy fogyasztóvédelmi jogait{" "}
        {country}-ban vagy az Ön lakóhelye szerinti EU-s országban is
        érvényesítheti.
      </p>
    </div>
    <div id="disputes">
      <h2>17. JOGVITÁK RENDEZÉSE</h2>
      <p>
        Az Európai Bizottság egy&nbsp;
        <a href="https://ec.europa.eu/consumers/odr">
          online vitarendezési platformot
        </a>
        &nbsp;kínál, amelyhez hozzáférhet. Amennyiben szeretné felhívni
        figyelmünket erre a témára, kérjük, lépjen velünk kapcsolatba.
      </p>
    </div>
    <div id="corrections">
      <h2>18. HELYESBÍTÉSEK</h2>
      <p>
        A Szolgáltatásokban előfordulhatnak tipográfiai hibák, pontatlanságok
        vagy hiányosságok, beleértve a leírásokat, árakat, elérhetőséget és
        egyéb információkat. Fenntartjuk a jogot, hogy bármely hibát,
        pontatlanságot vagy hiányosságot kijavítsunk, illetve bármikor, előzetes
        értesítés nélkül megváltoztassuk vagy frissítsük a Szolgáltatásokban
        található információkat.
      </p>
    </div>
    <div id="disclaimer">
      <h2>19. FELELŐSSÉG KIZÁRÁSA</h2>
      <p>
        A SZOLGÁLTATÁSOKAT „AHOGY VAN” ÉS „AHOGY ELÉRHETŐ” ALAPON NYÚJTJUK. ÖN
        ELFOGADJA, HOGY A SZOLGÁLTATÁSOKAT KIZÁRÓLAG SAJÁT FELELŐSSÉGÉRE
        HASZNÁLJA. A TÖRVÉNY ÁLTAL MEGENGEDETT LEGNAGYOBB MÉRTÉKBEN KIZÁRUNK
        MINDEN KIFEJEZETT VAGY HALLGATÓLAGOS SZAVATOSSÁGOT A SZOLGÁLTATÁSOKKAL
        KAPCSOLATBAN, IDEÉRTVE A FORGALOMKÉPESSÉGRE, MEGHATÁROZOTT CÉLRA VALÓ
        ALKALMASSÁGRA ÉS A JOGSÉRTÉS HIÁNYÁRA VONATKOZÓ SZAVATOSSÁGOKAT IS. NEM
        SZAVATOLJUK A SZOLGÁLTATÁSOK TARTALMÁNAK, ILLETVE BÁRMELY KAPCSOLT
        WEBOLDAL VAGY MOBILALKALMAZÁS TARTALMÁNAK PONTOSSÁGÁT VAGY TELJESSÉGÉT,
        ÉS NEM VÁLLALUNK FELELŐSSÉGET (1) TARTALMI HIBÁKÉRT, (2) SZEMÉLYI
        SÉRÜLÉSEKÉRT VAGY ANYAGI KÁROKÉRT, AMELYEK A SZOLGÁLTATÁSOK
        HASZNÁLATÁBÓL SZÁRMAZNAK, (3) ILLETÉKTELEN HOZZÁFÉRÉSÉRT SZERVEREINKHEZ
        ÉS AZ OTT TÁROLT ADATOKHOZ, (4) ÁTVITEL MEGSZAKADÁSÁÉRT, (5) HARMADIK
        FÉLTŐL SZÁRMAZÓ VÍRUSOKÉRT VAGY MÁS KÁROS ANYAGOKÉRT, (6) TARTALMI
        HIBÁKÉRT VAGY MULASZTÁSOKÉRT. NEM SZAVATOLUNK SEMMILYEN TERMÉKET VAGY
        SZOLGÁLTATÁST, AMELYET HARMADIK FÉL KÍNÁL, ÉS NEM VÁLLALUNK FELELŐSSÉGET
        SEMMILYEN TRANZAKCIÓÉRT ÖN ÉS BÁRMELY HARMADIK FÉL KÖZÖTT.
      </p>
    </div>
    <div id="liability">
      <h2>20. FELELŐSSÉG KORLÁTOZÁSA</h2>
      <p>
        SEMMILYEN ESETBEN SEM FELELÜNK ÖN FELÉ VAGY HARMADIK FÉL FELÉ SEMMILYEN
        KÖZVETLEN, KÖZVETETT, KÖVETKEZMÉNYES, PÉLDAÉRTÉKŰ, ESETI, KÜLÖNLEGES
        VAGY BÜNTETŐ JELLEGŰ KÁRÉRT, IDEÉRTVE AZ ELMARADT NYERESÉGET,
        BEVÉTELKIESÉST, ADATVESZTÉST VAGY EGYÉB KÁROKAT, AMELYEK A
        SZOLGÁLTATÁSOK HASZNÁLATÁBÓL SZÁRMAZNAK. FELELŐSSÉGÜNK ÖNNEL SZEMBEN
        MINDEN ESETBEN KORLÁTOZVA VAN A KÁR OKOZÁSA ELŐTTI HAT (6) HÓNAPBAN ÖN
        ÁLTAL FIZETETT ÖSSZEGRE. EGYES TÖRVÉNYEK EZEKET A KORLÁTOZÁSOKAT NEM
        ENGEDIK MEG, ÍGY ELŐFORDULHAT, HOGY EZEK A KORLÁTOZÁSOK ÖNRE NEM
        VONATKOZNAK.
      </p>
    </div>
    <div id="indemnification">
      <h2>21. KÁRTALANÍTÁS</h2>
      <p>
        Ön vállalja, hogy megvédi, kártalanítja és mentesíti minket,
        leányvállalatainkat, kapcsolt vállalkozásainkat, tisztségviselőinket,
        alkalmazottainkat és partnereinket minden olyan veszteség, kár,
        követelés, felelősség, igény és költség (beleértve az ügyvédi díjakat)
        alól, amelyek abból erednek, hogy Ön (1) használja a Szolgáltatásokat,
        (2) megsérti ezen jogi feltételeket, (3) megsérti bármely szavatosságát,
        (4) megsérti harmadik fél jogait, (5) ártalmasan jár el más
        felhasználókkal szemben. Fenntartjuk a jogot, hogy saját költségére
        kizárólagosan védjük azokat az ügyeket, amelyekért Önnek kártalanítania
        kell minket.
      </p>
    </div>
    <div id="userdata">
      <h2>22. FELHASZNÁLÓI ADATOK</h2>
      <p>
        Bizonyos adatokat tárolunk, amelyeket Ön továbbít a Szolgáltatások
        részére, a Szolgáltatások teljesítményének kezelése céljából, valamint a
        Szolgáltatások használatával kapcsolatos adatokat is. Bár rendszeres
        adatmentéseket végzünk, kizárólag Ön felelős minden olyan adatért,
        amelyet továbbít, vagy amely bármely, a Szolgáltatások használata során
        végzett tevékenységéhez kapcsolódik. Ön elfogadja, hogy nem vállalunk
        felelősséget az ilyen adatok elvesztéséért vagy sérüléséért, és ezennel
        lemond minden olyan követelésről, amely ezen adatok elvesztéséből vagy
        sérüléséből ered.
      </p>
    </div>
    <div id="electronic">
      <h2>23. ELEKTRONIKUS KOMMUNIKÁCIÓ, TRANZAKCIÓK ÉS ALÁÍRÁSOK</h2>
      <p>
        A Szolgáltatások meglátogatása, e-mailek küldése számunkra, valamint
        online űrlapok kitöltése elektronikus kommunikációnak minősül. Ön
        hozzájárul az elektronikus kommunikáció fogadásához, és elfogadja, hogy
        minden elektronikus úton, e-mailben vagy a Szolgáltatásokon keresztül
        nyújtott megállapodás, értesítés, közlés és egyéb kommunikáció kielégíti
        a jogi követelményeket, miszerint ezen kommunikáció írásban kell
        történjen. ÖN EZENNEL ELFOGADJA AZ ELEKTRONIKUS ALÁÍRÁSOK, SZERZŐDÉSEK,
        MEGRENDELÉSEK ÉS EGYÉB NYILVÁNTARTÁSOK HASZNÁLATÁT, VALAMINT A
        SZOLGÁLTATÁSOKON KERESZTÜL KEZDEMÉNYEZETT VAGY LEZÁRT TRANZAKCIÓKHOZ
        KAPCSOLÓDÓ ÉRTESÍTÉSEK, SZABÁLYZATOK ÉS NYILVÁNTARTÁSOK ELEKTRONIKUS
        KÉZBESÍTÉSÉT. Ön ezennel lemond minden olyan jogról vagy követelményről,
        amely megkövetelné az eredeti aláírást vagy nem elektronikus
        nyilvántartások tárolását, illetve nem elektronikus fizetést vagy
        hitelnyújtást.
      </p>
    </div>
    <div id="misc">
      <h2>24. EGYÉB RENDELKEZÉSEK</h2>
      <p>
        Ezek a jogi feltételek és minden, általunk a Szolgáltatásokon közzétett
        szabályzat vagy működési szabályzat teljes mértékben meghatározzák az Ön
        és köztünk fennálló megállapodást és kölcsönös megértést. Az, hogy
        bármely jogot vagy rendelkezést nem érvényesítünk, nem jelenti azt, hogy
        lemondunk róla. Ezen jogi feltételek a törvény által megengedett
        legteljesebb mértékben érvényesek. Jogunkban áll jogainkat és
        kötelezettségeinket bármikor másokra átruházni. Nem vagyunk felelősek
        semmilyen veszteségért, kárért, késedelemért vagy mulasztásért, amely
        olyan okból ered, amely rajtunk kívül áll. Ha bármely rendelkezés vagy
        annak része jogellenesnek, érvénytelennek vagy érvényesíthetetlennek
        bizonyul, az adott rendelkezés elválaszthatónak tekintendő, és nem
        érinti a fennmaradó rendelkezések érvényességét és végrehajthatóságát.
        Ön és köztünk nem jön létre sem közös vállalkozás, sem partnerség, sem
        munka-, sem képviseleti viszony ezen jogi feltételek vagy a
        Szolgáltatások használata következtében. Elfogadja, hogy ezeket a jogi
        feltételeket nem értelmezik hátrányunkra amiatt, hogy mi állítottuk
        össze őket. Ön ezennel lemond minden olyan védelemről, amely az ezen
        jogi feltételek elektronikus formájából vagy a felek általi aláírás
        hiányából eredne.
      </p>
    </div>
    <div id="contact">
      <h2>25. KAPCSOLAT</h2>
      <p>
        A Szolgáltatásokkal kapcsolatos panaszok megoldása vagy további
        információ kérése érdekében kérjük, lépjen velünk kapcsolatba:
      </p>
      <p>
        <strong>{company}</strong>
      </p>
      <p>
        {address}, {city}, {province} {postalCode} {country}
      </p>
      <ul>
        <li>
          <strong>Telefon:</strong> {phone}
        </li>
        <li>
          <strong>E-mail:</strong> {email}
        </li>
      </ul>
    </div>
  </>
);
